import { __rest } from "tslib";
import React from 'react';
import { TimePicker as BaseTimePicker, Icon, TextField } from '@groupby/ui-components';
import { useLocalization } from '@/localization';
export const TimePicker = (_a) => {
    var { selectedDateTime, setSelectedTime } = _a, props = __rest(_a, ["selectedDateTime", "setSelectedTime"]);
    const { formatMessage: t, getLocale } = useLocalization();
    const selectedLanguage = getLocale();
    const handleDateChange = (time) => setSelectedTime(time);
    return (<BaseTimePicker step={300} disabled={false} id="start-time" label={t({ key: 'RULE_CREATE_DATE_RANGE_START_TIME_LABEL' })} handleDateChange={handleDateChange} 
    // `null`, never `undefined`: MUI-X treats an `undefined` first value as
    // uncontrolled for the picker's lifetime, so a later date would never
    // reach it and picking a time would rebuild the value from today.
    selectedTime={selectedDateTime ? new Date(selectedDateTime) : null} cancelLabel={t({ key: 'CANCEL' })} okLabel={t({ key: 'OK' })} locale={selectedLanguage} enableAccessibleFieldDOMStructure={false} slots={{
            openPickerIcon: () => <Icon variant="clock"/>,
            textField: TextField,
        }} slotProps={{
            textField: {
                variant: 'standard',
            },
        }} {...props}/>);
};
export default TimePicker;
